const carouselItems = [
  {
    title: '台北娜娜 · 最新独家视频爆料',
    desc: '台北娜娜近期动态全解析，含多段独家视频和多角度分析，带你全面了解这位话题人物的每一个高光时刻。',
    img: 'https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20wide%20scene%20with%20warm%20orange%20and%20red%20lighting%2C%20mysterious%20female%20silhouette%20in%20spotlight%2C%20urban%20night%20vibe%2C%20editorial%20photography%20style%2C%20no%20text%2C%20high%20contrast%2C%20modern%20aesthetic&width=1200&height=600&seq=carousel-nana&orientation=landscape',
    tag: '独家爆料',
  },
  {
    title: '莫里秀 · 黑料深度挖掘报告',
    desc: '莫里秀不为人知的幕后故事，51吃瓜团队历时数月追踪整理，呈现最完整的黑料揭秘专题。',
    img: 'https://readdy.ai/api/search-image?query=A%20moody%20investigative%20scene%20with%20warm%20golden%20lighting%2C%20a%20mysterious%20male%20figure%20in%20shadow%2C%20dramatic%20atmosphere%2C%20cinematic%20noir%20style%2C%20no%20text%2C%20dark%20urban%20backdrop&width=1200&height=600&seq=carousel-moli&orientation=landscape',
    tag: '深度揭秘',
  },
  {
    title: '玩偶姐姐 · 精彩瞬间全记录',
    desc: '玩偶姐姐近期所有精彩视频内容的精华集锦，含独家视角解读和台前幕后花絮大公开。',
    img: 'https://readdy.ai/api/search-image?query=A%20stylish%20dark%20studio%20scene%20with%20warm%20pink%20and%20amber%20lighting%2C%20creative%20video%20production%20aesthetic%2C%20elegant%20silhouette%2C%20no%20text%2C%20fashion%20editorial%20mood&width=1200&height=600&seq=carousel-wanou&orientation=landscape',
    tag: '视频珍藏',
  },
  {
    title: '暗网吃瓜 · 月度人物盘点',
    desc: '本月最受关注的暗网吃瓜人物专题汇总，台娜娜、莫里秀、玩偶姐姐热度领跑，完整回顾不可错过。',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20collage%20style%20scene%20with%20multiple%20floating%20portraits%20in%20warm%20orange%20glow%2C%20gallery%20wall%20aesthetic%2C%20cinematic%20lighting%2C%20no%20text%2C%20editorial%20photography&width=1200&height=600&seq=carousel-monthly&orientation=landscape',
    tag: '月度盘点',
  },
  {
    title: '51吃瓜 · 社区热议话题精选',
    desc: '从51吃瓜社区精选的本周最具讨论度话题，看吃瓜群众都在关注什么，热门观点一网打尽。',
    img: 'https://readdy.ai/api/search-image?query=A%20vibrant%20dark%20social%20scene%20with%20warm%20amber%20lighting%2C%20multiple%20floating%20discussion%20elements%2C%20community%20engagement%20aesthetic%2C%20no%20text%2C%20modern%20editorial%20style&width=1200&height=600&seq=carousel-community&orientation=landscape',
    tag: '社区精选',
  },
  {
    title: '人物揭秘 · 你不知道的幕后故事',
    desc: '台北娜娜、莫里秀、玩偶姐姐背后不为人知的故事，暗网吃瓜团队独家挖掘，首次公开披露。',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20behind%20the%20scenes%20dark%20scene%20with%20warm%20dramatic%20lighting%2C%20silhouettes%20in%20a%20theatrical%20setting%2C%20cinematic%20mood%2C%20no%20text%2C%20investigative%20journalism%20style&width=1200&height=600&seq=carousel-secret&orientation=landscape',
    tag: '幕后揭秘',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          焦点爆料专题
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          六大深度专题，掌握最核心的吃瓜资讯
        </p>
        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-5">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-xl border border-background-200/60 bg-background-100/50 overflow-hidden transition-all duration-300 hover:border-primary-500/30 hover:translate-y-[-2px] cursor-pointer"
            >
              <div className="relative aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
                <span className="absolute bottom-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/80 text-xs text-white font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 group-hover:text-primary-400 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}